import { render } from "./BirthdayView.vue?vue&type=template&id=5217cb17"
import script from "./BirthdayView.vue?vue&type=script&lang=js"
export * from "./BirthdayView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/janbergler/NPM/MPM/V3/mpm/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__